/* eslint-disable consistent-return */
/* eslint-disable strict */

'use strict';

(function GeoLocate() {
  var simbaGeoLocation;
  var simbaGeoRegion;
  var storeCountryCode;
  var dataMap;
  var $panel;
  var $panelText;
  var $closeTrigger;

  // Get cookie (if set)
  if (!Simba.Cookie) return false;
  simbaGeoLocation = Simba.Cookie.read('simba-geocheck-location');
  simbaGeoRegion = Simba.Cookie.read('simba-geocheck-region');

  // Set for current store
  storeCountryCode = Simba.countryCode;

  // prettier-ignore
  dataMap = {
    'GB': {
      text: 'Looks like you’re visiting from the UK <a href="https://simbasleep.com">visit the UK site</a>',
      color: '#ff0000'
    },
    'FR': {
      text: 'Il semblerait que vous soyez en France. <a href="https://simbasleep.fr">Cliquez ici pour visiter le site français</a>.',
      color: '#ff0000'
    },
    'CA': {
      text: 'Looks like you’re visiting from Canada <a href="https://simbasleep.ca">visit the Canadian site</a>',
      color: '#ff0000'
    },
    'ES': {
      // eslint-disable-next-line max-len
      text: 'Parece que estás realizando la búsqueda desde España. <a href="https://simbacolchon.es">Visite el sitio web en español</a>.',
      color: '#ff0000'
    }
  };

  // Define Theme Elements
  $panel = document.querySelector('[data-geo-dropdown]');
  $panelText = document.querySelector('[data-geo-dropdown-text]');
  $closeTrigger = document.querySelector('[data-geo-dropdown-close]');

  // Only get location and redirect if we haven't already got a cookie stored
  if (!simbaGeoLocation || !simbaGeoRegion) {
    fetch('/browsing_context_suggestions.json')
      .then((response) => response.json())
      .then((data) => {
        let countryCode = false;
        let regionName = false;
        countryCode = data?.detected_values?.country?.handle;
        regionName = data?.detected_values?.country_name;

        if (countryCode && regionName) {
          // Set Cookies
          Simba.Cookie.create('simba-geocheck-location', countryCode, 1);
          Simba.Cookie.create('simba-geocheck-region', regionName, 1);

          // Calc Any Country Specific Finance
          geoFinance(regionName);

          // Exit If Country Code Not Featured or Correct Location
          if (countryCode === storeCountryCode || !dataMap[countryCode]) return false;

          // Set Message & Colour
          const countryMsg = dataMap[countryCode].text;
          const color = dataMap[countryCode].color;

          // Show Dropdown Message
          $panel.style.background = color;
          $panel.style.height = setCssHeightVar;
          $panelText.innerHTML = countryMsg;
          $panel.setAttribute('aria-hidden', 'false');
          $panel.classList.remove('hidden');
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.warn('Geolocation error:', error);
      });
  } else {
    geoFinance(simbaGeoRegion);
  }

  // Set Close Trigger
  $closeTrigger.addEventListener('click', function () {
    $panel.classList.add('hidden');
    $panel.setAttribute('aria-hidden', 'true');
  });

  function setCssHeightVar() {
    const height = document.querySelector('[data-geo-dropdown]')?.getBoundingClientRect()?.height ?? 0;
    document.documentElement.style.setProperty('--geo-dropdown-height', `${height}px`);
  }

  // Geo Region Check / Hide Finance
  function geoFinance(region) {
    var i;
    var messages = document.querySelectorAll('[data-finance-region]');
    var mLength = messages.length;
    var credit = false;
    if (!region) region = Simba.Cookie.read('simba-geocheck-region');
    if (region === '') {
      credit = 'Credit available';
    }
    for (i = 0; i < mLength; i++) {
      if (credit) messages[i].innerHTML = credit;
      messages[i].style.display = 'block';
    }
  }
})();
